import React from 'react';
import { Button, Icon } from 'antd';
import cn from 'classnames';
import styles from './BackButton.module.scss';

const BackButton = ({ className, onClick }) => {
  return (
    <Button onClick={onClick} className={cn(styles.root, className)}>
      <Icon type="left" />
    </Button>
  );
};

export default BackButton;